import styled from '@emotion/styled'
import { Description } from '../../Description'
import { StyledHTMLElement } from 'shop/theme/types'
import Allergens from '../Content/Allergens'
import DietaryRequirements from '../Content/DietaryRequirements'
import { DescriptionType } from 'shop/components/Description/types'
import { DietaryRequirement } from 'shop/components/Shop/Categories'
import PromoTag from 'shop/components/Product/PromoTag'
import { Promotion } from 'shop/types'

interface Props {
  description: string | null
  calorieData?: number
  allergens: string[]
  dietaryRequirements: DietaryRequirement[]
  forceShowDescription: boolean
  promotion: Promotion | null
}

const ProductDetails = ({
  description = '',
  calorieData,
  allergens,
  forceShowDescription = false,
  dietaryRequirements,
  promotion
}: Props) => {
  const noDetails = !description && !calorieData && !allergens?.length
  if (noDetails) return <></>

  return (
    <Container data-testid='product-details'>
      <PromoDietContent>
        {promotion && (
          <PromoTag
            promotion={promotion}
            styles={{
              position: 'static',
              top: '4px',
              right: '4px',
              left: 'auto',
              bottom: 'auto',
              padding: '4px 8px',
              fontSize: '14px',
              zIndex: 0
            }}
          />
        )}
        <DietaryInformation>
          {!!calorieData && (
            <CalorieDetails>
              {calorieData}kcal<span> *Adults need around 2000kcal a day</span>
            </CalorieDetails>
          )}
          <DietaryRequirements dietaryRequirements={dietaryRequirements} />
        </DietaryInformation>
      </PromoDietContent>
      {!!description && (
        <Description
          description={description}
          forceShowDescription={forceShowDescription}
          type={DescriptionType.PRODUCT}
        />
      )}
      {!!allergens?.length && <Allergens allergens={allergens} />}
      {/* when we force show, it means nothing below, so no need for a divider */}
      {!forceShowDescription && <Divider />}
    </Container>
  )
}

const PromoDietContent = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  gap: theme.space[2],
  marginBottom: theme.space[2]
}))

const Divider = styled.hr<StyledHTMLElement>(() => ({
  border: 0,
  margin: 0,
  padding: 0,
  borderBottom: '2px solid #F0F0F0'
}))

const Container = styled.div<StyledHTMLElement>(() => ({
  padding: '0 0 24px'
}))

const DietaryInformation = styled.div<StyledHTMLElement>(({ theme }) => ({
  color: theme.colors['textMute'],
  fontSize: '14px'
}))

const CalorieDetails = styled.span<StyledHTMLElement>({
  fontSize: '12px',
  fontStyle: 'italic',
  marginRight: '8px'
})

export default ProductDetails
